<template>
   <div class="homeContainerRefuge">
      <br><br>
      <br><br>
      <br><br>
      <br>
      <div class="container">
        <div class="row">
            <div class="col-lg-11 col-9">
                 <h3 class="font-weight-bold mb-4 centers" id="top">Fiche de {{ animal.name }}</h3>
            </div>
            <div class="col-lg-1 col-3 text-end" style="margin-top: 10px;"  v-if="nextAnimal">
                <router-link :to="`/animaux/${nextAnimal.id}`">
                    <i class="fas fa-arrow-right fa-2x"></i>
                </router-link>
            </div>
        
            <br>
       
         <div class="mid">
         </div>
         </div>

      </div>
      <div class="container">
         <div class="row">
            <div class="col-lg-4">
               <template v-if="animal.huge_information">
                  <span><b>Information importante :</b> {{ animal.huge_information }}</span>
                  <br><br>
               </template>
               <template v-if="animal.naissance">
                  <b>Date naissance :</b> {{ formaterDate(animal.naissance) }}
                  <br><br>
               </template>
               <template v-if="animal.arrive">
                  <b>Date d'arrivée :</b> {{ formaterDate(animal.arrive) }}
                  <br><br>
               </template>
               <template v-if="animal.sexe">
                  <b>Sexe :</b> {{ animal.sexe === 'female' ? 'femelle' : animal.sexe }}
                  <br><br>
               </template>
               <template v-if="animal.caractere">
                  <b>Caractère :</b> {{ animal.caractere }}
                  <br><br>
               </template>
               <template v-if="animal.ville">
                  <b>Ville :</b> {{ animal.ville }}
                  <br><br>
               </template>
               <template v-if="animal.race">
                  <b>Race :</b> {{ animal.race }}
                  <br><br>
               </template>
               
               <template v-if="animal.identifie">
                  <b>Identifié :</b> {{ animal.identifie }}
                  <br><br>
               </template>
               <template v-if="animal.sterilise">
                  <b>Stérilisé :</b> {{ animal.sterilise }}
                  <br><br>
               </template>
               <template v-if="animal.vaccin">
                  <b>Vacciné :</b> {{ animal.vaccin }}
                  <br><br>
               </template>

               <template v-if="animal.couleur">
                  <b>Couleur :</b> {{ animal.couleur }}
                  <br><br>
               </template>
               <template v-if="animal.entente_chien">
                  <b>Entente avec chien :</b> {{ animal.entente_chien }}
                  <br><br>
               </template>
               <template v-if="animal.entente_chat">
                  <b>Entente avec chat :</b> {{ animal.entente_chat }}
                  <br><br>
               </template>
               <template v-if="animal.entente_enfant">
                  <b>Entente avec enfant :</b> {{ animal.entente_enfant }}
                  <br><br>
               </template>
            </div>
            <div class="col-lg-8 responsive">
               <br>
               <br>
               <div v-html="descriAnimal"></div>
               <br>
               <br>
               <div class="row">
                  <div class="col-lg-6" v-if="animal.img1">
                     <br><br>
                     <img :src="'https://admin.asso-refuge.fr/images/' + animal.img1"
                        :alt="'photo du nacs ' + animal.name + ' de l assocation Association Justice Pour Les Animaux / A.J.P.L.A. deNice'"
                        :title="animal.name + ' ' + animal.race ?? animal.couleur" style="width: 100%;" />
                  </div>
                  <div class="col-lg-6" v-if="animal.img2">
                     <br><br>
                     <img :src="'https://admin.asso-refuge.fr/images/' + animal.img2"
                        :alt="'photo du nacs ' + animal.name + ' de l assocation Association Justice Pour Les Animaux / A.J.P.L.A. deNice'"
                        :title="animal.name + ' ' + animal.race ?? animal.couleur" style="width: 100%;" />
                  </div>
                  <div class="col-lg-6" v-if="animal.img3">
                     <br><br>
                     <img :src="'https://admin.asso-refuge.fr/images/' + animal.img3"
                        :alt="'photo du nacs ' + animal.name + ' de l assocation Association Justice Pour Les Animaux / A.J.P.L.A. deNice'"
                        :title="animal.name + ' ' + animal.race ?? animal.couleur" style="width: 100%;" />
                  </div>
                  <div class="col-lg-6" v-if="animal.img4">
                     <br><br>
                     <img :src="'https://admin.asso-refuge.fr/images/' + animal.img4"
                        :alt="'photo du nacs ' + animal.name + ' de l assocation Association Justice Pour Les Animaux / A.J.P.L.A. deNice'"
                        :title="animal.name + ' ' + animal.race ?? animal.couleur" style="width: 100%;" />
                  </div>
                  <div class="col-lg-6" v-if="animal.img5">
                     <br><br>
                     <img :src="'https://admin.asso-refuge.fr/images/' + animal.img5"
                        :alt="'photo du nacs ' + animal.name + ' de l assocation Association Justice Pour Les Animaux / A.J.P.L.A. deNice'"
                        :title="animal.name + ' ' + animal.race ?? animal.couleur" style="width: 100%;" />
                  </div>
               </div>
               <br>
               <br>
            </div>
         </div>
      </div>
      <br><br>
      <br><br>
      <br><br>
      <br><br>
   </div>
</template>
<style src="../assets/css/besoins.css"></style>
<script>
import convertAge from '../components/getAge.js';

export default {
  data() {
    return {
      animal: {},
      animaux: [],
      formatdatearrive: null,
      formatdatenaissance: null
    };
  },

  mounted() {
    // on utilise le watch pour charger l'animal
  },

  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        this.loadAnimal(newId);
      }
    }
  },

  computed: {
    // Description avec sauts de ligne
    descriAnimal() {
      if (this.animal.description) {
        return this.animal.description.replace(/\r\n/g, '<br>');
      }
      return '';
    },

    // Prochain animal du même type (circulaire)
    nextAnimal() {
      if (!this.animaux.length || !this.animal?.type) return null;

      // Liste de tous les animaux du même type
      const sameType = this.animaux.filter(a => a.type === this.animal.type);

      if (sameType.length <= 1) return null; // pas d'autre animal

      // Index de l'animal courant dans la liste
      const currentIndex = sameType.findIndex(a => a.id === this.animal.id);

      // Prochain animal circulaire
      const nextIndex = (currentIndex + 1) % sameType.length;
      return sameType[nextIndex];
    }
  },

  methods: {
    // Charge l'animal courant et tous les animaux
    loadAnimal(id) {
      const idSite = this.$idSite;

      // Détails animal
      fetch(`https://admin.asso-refuge.fr/getAnimalDetails/${idSite}/${id}`)
        .then(res => res.json())
        .then(data => {
          this.animal = data[0];
          this.formatdatearrive = data.formatdatearrive;
          this.formatdatenaissance = data.formatdatenaissance;
        })
        .catch(err => console.error('Erreur fetch animal:', err));

      // Tous les animaux (si non déjà chargés)
      if (!this.animaux.length) {
        fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
          .then(res => res.json())
          .then(data => {
            this.animaux = data;
          })
          .catch(err => console.error('Erreur fetch animaux:', err));
      }
    },

    // Calcul âge
    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },

    // Formater une date
    formaterDate(dateString) {
      if (!dateString) return 'Inconnu';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return 'Inconnu';
      const options = { day: '2-digit', month: 'long', year: 'numeric' };
      return date.toLocaleDateString('fr-FR', options);
    },

    closeTab() {
      window.close();
    }
  }
};
</script>